module.exports = __webpack_public_path__ + "img/assets.26b1fad8.svg";